(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .directive('sectionValidation', ['$stateParams', sectionValidation]);

    function sectionValidation ($stateParams) {
        var directive = {
            restrict: 'AE',
            link: link,
            transclude: true,
            require: 'ngModel',
            templateUrl: 'app/components/dynamic-form/section-validation.template.html',
            scope: {}
        };

        return directive;

        function link(scope, elm, attrs, modelCtrl) {
            var errorKeyPrefix = modelCtrl.$name + '.';

            // Mark this model as a section
            modelCtrl.$isSection = true;

            // Don't show validation icons for third party forms
            if (modelCtrl.$name === 'thirdParty') {
                scope.hasErrors = false;
                scope.valid = function() { return null; };
                return;
            }

            // Initialize hasErrors to false to prevent showing error icons by default
            scope.hasErrors = false;

            // Update validation status whenever new validations are recieved
            scope.$on("validationsUpdated", function(event, errors, currentSectionData) {
                // Only set hasErrors to true if there are actual validation errors
                // and the section has been started
                var sectionData = modelCtrl.$modelValue;
                var sectionStarted = sectionData ? sectionData.$started : false;
                
                // Don't show validation errors if the section hasn't been started yet
                if (!sectionStarted) {
                    scope.hasErrors = false;
                    return;
                }
                
                // Check if there are any validation errors for this section
                var hasSectionErrors = false;
                if (errors) {
                    hasSectionErrors = Object.keys(errors).some(function(errorKey) {
                        return errorKey.startsWith(errorKeyPrefix) && errors[errorKey] && Object.keys(errors[errorKey]).length > 0;
                    });
                }
                
                scope.hasErrors = hasSectionErrors;
            });

            // Return true if the section is valid (no errors)
            scope.valid = function() {
                return !scope.hasErrors;
            };
        }
    }
})();
